import React, { Component, Fragment } from 'react'
import { Translate } from '../../contexts/Language';
import { BreadCrumb, Card } from '../../components';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import DataTableExtensions from 'react-data-table-component-extensions';
import { Config } from '../../config';
import { Service } from '../../services';

export class CoinAddressList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: []
        }
    }
    componentDidMount() {

        Service.CryptoService.AddressWhiteList().then(response => {

            if (response) {
                this.setState({
                    data: response
                });
            }

        });
    }

    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Coin Address List")} Name={Translate("Coin Address List")} />
                <Card Title="Coin Address List" Description="Coin Address List">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-12">
                                <DataTableExtensions columns={DataTableColumns.coinAddressList} data={this.state.data} exportHeaders={true}>
                                    <DataTable
                                        noHeader={true}
                                        defaultSortField="id"
                                        defaultSortAsc={false}
                                        pagination
                                        highlightOnHover />
                                </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                </Card>
            </Fragment>)
    }
}